function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 47.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#418fde",
    d: "M16 0C7.16 0 0 7.6 0 16.96c0 8.06 11.83 25.67 15.15 30.45a1.018 1.018 0 0 0 1.7 0C20.17 42.63 32 25.02 32 16.96 32 7.6 24.84 0 16 0zm0 23.87a8 8 0 1 1 8-8 7.998 7.998 0 0 1-8 8z",
    "data-name": "Layer 2",
    style: {
      fill: "#000000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.ff94fc3c5e15080959fec0e2fb9836ec.svg";
export { ForwardRef as ReactComponent };